import {
  DeleteOutlined,
  EditFilled,
  EyeOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";

import { useEffect, useRef, useState,forwardRef, useImperativeHandle } from "react";

import { useNotification } from "../../../hooks/useNotification.js";
import { JournalAPIService } from "../../../services/api/JournalAPIService";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE, DATE } from "../../../shared/constants";
import ConfirmationDialog from "../../common/ConfirmationDialog.js";
import CardTemplateEdit from "./CardTemplateEdit.js";
import ActionMenu from "../../../pages/Extra/ActionMenu.js";
import html2canvas from "html2canvas";
import DownloadBackdrop from "../../../pages/Memory_journal/DownloadBackdrop.js";


const CardTemplate = forwardRef((props,ref) => {
  const {
    journalId,
    author,
    headingText,
    bodyText,
    date,
    bgColor = "#007aff",
    headingColor = "#ff92ac",
    textColor = "#ffffff",
    borderColor = "pink",
    imageTopLeft,
    imageTopLeftStyle,
    imageTopRight,
    imageTopRightStyle,
    imageBottomLeft,
    imageBottomLeftStyle,
    imageBottomRight,
    imageBottomRightStyle,
    disableEye = false,
    editData = false,
    pageRefreshCallback,
    menuShow
  } = props;
  const cardRef = useRef(null);
  const { notifyError, notifySuccess } = useNotification();

  const [showEye, setShowEye] = useState(false);
  const [open, setOpen] = useState(false);
  const [editMode, setEditOpen] = useState(editData);
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const openMenu = Boolean(anchorEl);

  useImperativeHandle(ref, () => ({
      getCardElement: () => cardRef.current,
    }));

  const handleMenuClick = (action) => {
    switch (action) {
      case "edit":
        handleEdit();
        break;
      case "delete":
        handleDelete();
        break;
      case "save":
        handleDownloadImage();
        break;
      case "view":
        handleOpenDialog();
        break;
      case "effect":
        // handleOpenEditor(imgSrc, journalId);
        break;
      case "drag":

        console.log("Drag action triggered");
        // Optional: set some dragging state here
        break;
      default:
        break;
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setShowEye(false);
  };

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => {
    setOpen(false);
    setEditOpen(false);
    setShowEye(false);
  };

  const handleEdit = () => {
    if (!disableEye) {
      setOpen(true);
    }
    setShowEye(false);
    setEditOpen(true);
  };

  const handleSubmit = () => {
    handleCloseDialog();
  };

  const handleDelete = () => {
    handleCloseDialog();
    setConfirmDialogOpen(true);
  };

  const handleCancelDelete = () => {
    setConfirmDialogOpen(false);
  };

  const handleConfirmDelete = () => {
    setConfirmDialogOpen(false);

    JournalAPIService.journalDelete(journalId)
      .then((response) => {
        notifySuccess(response.message || API_SUCCESS_MESSAGE.DELETED_SUCCESSFULLY);
        pageRefreshCallback();
      })
      .catch((errResponse) => {
        notifyError(
          errResponse?.response?.data?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
        );
      });
    handleCloseDialog();
  };

  const handleDownloadImage = async () => {
    if (!cardRef.current) return;

    try {
      setDownloading(true);

      const canvas = await html2canvas(cardRef.current, {
        useCORS: true,
        backgroundColor: null,
        scale: 7,
      });

      const hashCode = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = (hash << 5) - hash + str.charCodeAt(i);
          hash |= 0;
        }
        return Math.abs(hash % 10000);
      };

      const shortCode = hashCode(journalId);

      const dataUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `IMG_${shortCode}.png`;
      link.click();
      notifySuccess(API_SUCCESS_MESSAGE.DOWNLOAD_REEL);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
    {menuShow &&
    <IconButton
                        sx={{
                          position: "absolute",
                          top: 12,
                          right: 10,
                          color: "black",
                          zIndex: 1001,
                          width: { xs: "25px", sm: "30px", md: "30px" },
                          height: { xs: "25px", sm: "30px", md: "30px" },
                          "@media (max-width: 440px)": {
                            height: "20px",
                            width: "20px",
                            top:15,
                            right:10
                          },
                          // bgcolor: "#ffffffc9",
                        }}
                        // onClick={handleMenuClick}
                      >
                 <ActionMenu action={handleMenuClick} show={true} drag={true} fullView={true}/>
                  </IconButton>
                  }
      <Box
        ref={cardRef}
        sx={{
          width: {
            xs: disableEye ? "84%" : "84%",
            sm: disableEye ? "60%" : "90%",
            md: disableEye ? "60%" : "90%",
          },
          height: { xs: 232, sm: 320, md: 320 },
          "@media (max-width: 370px)": {
              height: disableEye ? 300 : 232,
            },
          "@media (min-width: 310px) and (max-width: 360px)": {
            height: 210,
          },

          marginTop: {
            xs: disableEye ? "10%" : "1%",
            sm: disableEye ? "6%" : "1%",
            md: disableEye ? "6%" : "1%",
          },
          bgcolor: bgColor,
          borderRadius: "16px",
          border: `4px solid ${borderColor}`,
          color: textColor,
          p: "10px",
          position: "relative",
          overflow: "hidden",
          textAlign: "center",
          justifySelf: "center",
          fontFamily: "Arial, sans-serif",
        }}
        onMouseEnter={() => setShowEye(true)}
        onMouseLeave={() => setShowEye(false)}
      >

        {/* {showEye && !disableEye && (
          <IconButton
            onClick={handleOpenDialog}
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 1000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(0,0,0,0.5)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
              borderRadius: 0,
            }}
          >
            <EyeOutlined style={{ fontSize: 40, color: "white" }} />
          </IconButton>
        )} */}

        {/* Dynamic Images */}
        {imageTopLeft && (
          <Box
            component="img"
            src={imageTopLeft}
            alt="top-left"
            sx={{
              position: "absolute",
              ...imageTopLeftStyle,
            }}
          />
        )}

        {imageTopRight && (
          <Box
            component="img"
            src={imageTopRight}
            alt="top-right"
            sx={{
              position: "absolute",
              ...imageTopRightStyle,
            }}
          />
        )}

        {imageBottomLeft && (
          <Box
            component="img"
            src={imageBottomLeft}
            alt="bottom-left"
            sx={{
              position: "absolute",
              ...imageBottomLeftStyle,
            }}
          />
        )}

        {imageBottomRight && (
          <Box
            component="img"
            src={imageBottomRight}
            alt="bottom-right"
            sx={{
              position: "absolute",
              borderRadius: "50%",
              ...imageBottomRightStyle,
            }}
          />
        )}
       <Box
  sx={{
    mt:"26%",

    alignSelf:
      bodyText?.length < 150 || editMode || disableEye ? "center" : "stretch",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height:"230px",

    justifyContent: "center",
    textAlign: "center", // Applies to Typography children
    "@media (min-width: 310px) and (max-width: 440px)": {
      mt:"23%",
      height:"180px",
    },
  }}
>
  <Typography
    sx={{
      fontWeight: "bold",
      fontSize: {
        xs: "0.7rem",
        sm: "1rem",
        md: "1rem",
      },
      mb: 2,
      color: headingColor,
    }}
  >
    {headingText}
  </Typography>

  <Typography
    sx={{
      fontSize: {
        xs:
          bodyText?.length < 150 || editMode || disableEye
            ? "0.7rem"
            : "0.6rem",
        sm: "0.9rem",
        md: "0.9rem",
      },
      "@media (max-width: 370px)": {
        fontSize: "0.5rem",
      },
      color: textColor,
      lineHeight: 1.6,
    }}
  >
    {bodyText}
  </Typography>
</Box>

        {/* Date */}

          <Typography
            sx={{
              position: "absolute",
              bottom: 4,
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: { xs: "0.7rem", sm: "0.9rem", md: "0.9rem" },
              color: textColor,
            }}
          >
            {dayjs(date).format(DATE.JOURNAL_FORMAT)}
          </Typography>

      </Box>

      <ConfirmationDialog
        id="confirmation-dialog-description"
        open={confirmDialogOpen}
        title=""
        description="Are you sure you want to delete this memory?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        confirmText="Delete"
        cancelText="Cancel"
        keepMounted={false}
        transition="up"
        loading={false}
      />

      {open &&
      <CardTemplateEdit
        journalId={journalId}
        author={author}
        headingText={headingText}
        bodyText={bodyText}
        date={date}
        bgColor={bgColor}
        headingColor={headingColor}
        textColor={textColor}
        borderColor={borderColor}
        imageTopLeft={imageTopLeft}
        imageTopLeftStyle={imageTopLeftStyle}
        imageTopRight={imageTopRight}
        imageTopRightStyle={imageTopRightStyle}
        imageBottomLeft={imageBottomLeft}
        imageBottomLeftStyle={imageBottomLeftStyle}
        imageBottomRight={imageBottomRight}
        imageBottomRightStyle={imageBottomRightStyle}
        disableEye={true}
        editData={editMode}
        open={open}
        onClose={handleCloseDialog}
        pageRefreshCallback={pageRefreshCallback}
      />
}

<DownloadBackdrop downloading={downloading} />

    </>
  );
});
export default CardTemplate;
